<template>
  <el-table-column
    prop="completion_date"
    sortable="custom"
    label="Teljesítés"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.completion_date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'completion_date',
  };
</script>
